<template lang="pug">
</template>

<script>
export default {
  name: 'speakers',
  props: {
    page: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Speakers.vue